import { endpoints, EndpointEnvVar } from "@/config/endpoints";

type Resolver = (name: EndpointEnvVar) => string;

/** Default = static build-time value. */
const staticResolver: Resolver = (name) => endpoints[name];

let resolver: Resolver = staticResolver;

/**
 * Inject the Flagsmith resolver once at boot. Consumers never import the
 * feature-flag store directly, keeping this layer store-free.
 */
export function initEndpointResolver(fn: Resolver): void {
  resolver = fn;
}

/** Resolve an endpoint base URL at request-time (static default until injected). */
export function resolveEndpoint(name: EndpointEnvVar): string {
  return resolver(name);
}
